import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding, withDebugTracing } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { routes } from './app.routes';
import { BsModalService } from 'ngx-bootstrap/modal';
import { loggingInterceptor } from './interceptors/loggin.interceptor';

import { HTTP_INTERCEPTORS, provideHttpClient ,   withFetch, withInterceptors, withInterceptorsFromDi, withNoXsrfProtection } from '@angular/common/http';

import { provideAnimations } from '@angular/platform-browser/animations';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withDebugTracing()),

    provideAnimations(),
    BsModalService,
    provideHttpClient(withInterceptorsFromDi() ,withFetch(), withNoXsrfProtection(),withInterceptors([loggingInterceptor])),
  ]
};
